/**
 * CanvasModeTabs — Underline-style tab bar for switching between
 * interactive canvas modes. Compact Row 2 of the header.
 */

import { Grid3X3, Compass, Lightbulb, BookOpen } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useCanvasInteractive, type InteractiveMode } from './CanvasInteractiveContext'
import { ProgressRing } from './ProgressRing'

const MODES: Array<{
  id: InteractiveMode
  label: string
  icon: typeof Grid3X3
}> = [
  { id: 'canvas', label: 'Canvas', icon: Grid3X3 },
  { id: 'guided', label: 'Guided', icon: Compass },
  { id: 'challenges', label: 'Challenges', icon: Lightbulb },
  { id: 'story', label: 'Story', icon: BookOpen },
]

export function CanvasModeTabs() {
  const { activeMode, setActiveMode, sectionStats, selectedTemplate } = useCanvasInteractive()

  const filledSections = Object.values(sectionStats).filter((s) => s.count > 0).length
  const totalSections = selectedTemplate.sections.length

  return (
    <div className="flex-shrink-0 flex items-center px-1 border-b border-warm-200">
      <div className="flex items-center gap-px">
        {MODES.map(({ id, label, icon: Icon }) => {
          const isActive = activeMode === id
          return (
            <button
              key={id}
              onClick={() => setActiveMode(id)}
              className={cn(
                'flex items-center gap-1.5 px-3 py-2 text-xs font-medium',
                'whitespace-nowrap transition-colors border-b-2 -mb-px',
                isActive
                  ? 'text-text border-primary'
                  : 'text-text-muted hover:text-text-secondary border-transparent'
              )}
            >
              <Icon className={cn('w-3.5 h-3.5', isActive ? 'opacity-90' : 'opacity-50')} />
              {label}
            </button>
          )
        })}
      </div>
      <div className="flex-1" />
      <div className="pr-2">
        <ProgressRing filled={filledSections} total={totalSections} />
      </div>
    </div>
  )
}
